import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IHotel, IResponse } from '../@Interfaces';

@Injectable({
  providedIn: 'root',
})
export class HotelService {
  constructor(private http: HttpClient) {}

  public hotels: IHotel[] = [];
  public displayedHotels: IHotel[] = [];

  public async setHotels(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http
        .get<IResponse<IHotel[]>>(`/api/hotels`, {
          withCredentials: true,
        })
        .subscribe({
          next: (hotelsRes: IResponse<IHotel[]>) => {
            this.hotels = hotelsRes.data;
            resolve();
          },
          error: () => {
            console.log('error setting statistics');
            reject();
          },
        });
    });
  }
}
